<section class="date-range-container">
  <sh-text color="primary" size="header-2" class="local-coil"
    >Local Coils&nbsp;

    <ng-container
      *ngIf="dateRangeService.reversedDateRange$ | async; let dateRange"
    >
      <span class="dates">
        {{ dateRange.firstDate | localizedDate }} to
        {{ dateRange.lastDate | localizedDate }}
      </span>
    </ng-container>
  </sh-text>
</section>

<section
  class="coil-name-container"
  (click)="goBack()"
  (keydown.enter)="goBack()"
  tabindex="0"
>
  <sh-icon size="s" icon="arrow-line-left-s"></sh-icon>
  <p class="coil-name">Back to {{ coilName }}</p>
</section>

<section class="date-container">
  <sh-icon
    class="date-icon"
    size="m"
    [icon]="coilHistoryIcon"
    [ngStyle]="styles"
  ></sh-icon>
  <div class="date-font">
    <p class="dayOfWeek">{{ dayOfWeek }}</p>
    <p>, {{ calDay | localizedDate }}</p>
  </div>
</section>

<section class="table-container">
  <table>
    <thead>
      <tr class="table-title">
        <th>All Channels</th>
        <th>Status</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let element of coilElements; let i = index">
        <td class="table-coil-element">{{ element }}</td>
        <td class="table-icon">
          <ng-container
            *ngIf="setSmallGreyIcon(coilChannelIcon[i]); else defaultTableIcon"
          >
            <img class="dot-icon" src="assets/dot.svg" alt="Status Icon" />
          </ng-container>
          <ng-template #defaultTableIcon>
            <sh-icon
              size="xs"
              [icon]="coilChannelIcon[i]"
              [ngStyle]="styles"
            ></sh-icon>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
</section>
